import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ModuleKind } from 'app/library/module/enums/module-kind.enum';
import { Module } from 'app/library/module/models/module.model';

@Component({
    selector: 'app-copy-to-existing-module-dialog',
    templateUrl: './copy-to-existing-module-dialog.component.html',
    styleUrls: ['./copy-to-existing-module-dialog.component.scss'],
})
export class CopyToExistingDialogComponent {
    @Input()
    titleKey = 'GENERAL.BUTTON.COPY_TO_EXISTING';

    @Input()
    actionButtonKey = 'GENERAL.BUTTON.SAVE';

    @Input()
    allowedKinds: ModuleKind[];

    selectedModule: Module;
    currentModule: Module;

    constructor(public dialogRef: MatDialogRef<CopyToExistingDialogComponent>) {}

    saveSelectedModule(module: Module): void {
        this.selectedModule = module;
    }

    copyModule(): void {
        this.dialogRef.close({ data: this.selectedModule });
    }
}
